/**
 * Constants used for Job Facets Filters
 * @description: This file contains all the constants used for Job Facets Filters
 */

/**
 * @description This constant is used as the base url for the redux api fetches.
 * @description It is set in the Enqueue.php file from theme
 */
// eslint-disable-next-line no-undef
const BASE_API_URL = jobboardApp?.baseApiURL;

/**
 * @description This constant is used for fetching the job listing results.
 */
const JOBS_LISTINGS_API = 'jobs/';

/**
 * @description This constant is used for fetching the job facets filters.
 */
const JOBS_FACETS_API = 'job-filters/';

/**
 * @description This constant is used for naming redux reducer path
 */
const ROOT_REDUCER_PATH = 'apiReducer';

/**
 * @description This constant is used for naming jobs input slice name
 */
const JOBS_FORM_SLICE_NAME = 'jobsFormInput';

export {
	BASE_API_URL,
	JOBS_LISTINGS_API,
	JOBS_FACETS_API,
	ROOT_REDUCER_PATH,
	JOBS_FORM_SLICE_NAME,
};
